module.exports = __webpack_public_path__ + "static/media/subICloud4.adfebcf4.png";